import React from "react";
import { useTranslation } from "react-i18next";

import style from "./mcs.scss";
import QuickFilterButton from "components/table/QuickFilterButton";

import testIds from "testIds.json";

export enum McsFilter {
    ALL = "ALL",
    DISABLED = "DISABLED",
    UNREGISTERED = "UNREGISTERED",
    ACTIVE = "ACTIVE",
    DEACTIVATED = "DEACTIVATED",
}

interface McsQuickFiltersProps {
    activeFilter: McsFilter;
    onFilterChange: (filter: McsFilter) => void;
}

export const McsQuickFilters: React.FC<McsQuickFiltersProps> = ({ activeFilter, onFilterChange }) => {
    const { t } = useTranslation();

    const filters = [
        { key: McsFilter.ALL, label: t("Mcs.table.mcStatus.all") },
        { key: McsFilter.ACTIVE, label: t("Mcs.table.mcStatus.active") },
        { key: McsFilter.DISABLED, label: t("Mcs.table.mcStatus.disabled") },
        { key: McsFilter.DEACTIVATED, label: t("Mcs.table.mcStatus.deactivated") },
        { key: McsFilter.UNREGISTERED, label: t("Mcs.table.mcStatus.unregistered") },
    ];

    return (
        <div className={style.quickFiltersContainer}>
            <div data-testid={testIds.common.primaryView.table.filter.itself}>
                {filters.map((filter) => (
                    <QuickFilterButton
                        key={filter.key}
                        filter={filter.label}
                        isActive={activeFilter === filter.key}
                        onClick={() => onFilterChange(filter.key)}
                        testId={testIds.common.primaryView.table.filter.button}
                        dataType={filter.key}
                    />
                ))}
            </div>
        </div>
    );
};
